<template>
  <Body class="page-press" />

  <section class="page-header">
    <div class="wrap">
      <div class="text">
        <h1 class="title">
          {{ $t('언론보도') }}
        </h1>
        <div class="desc" v-html="$t('세상을바꾸는따뜻한실천br언론에소개된어머니사랑과평화의날캠페인소식을만나보세요')" />
      </div>
    </div>
  </section>

  <!-- ********** Special ********** -->
  <section class="section special-press">
    <div class="wrap">
      <ClientOnly>
        <Swiper
          class="paging-outside"
          :modules="[Pagination, Autoplay, Navigation]"
          :slides-per-view="1"
          :space-between="0"
          :autoplay="{
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }"
          :speed="500"
          :loop="true"
          :pagination="{ clickable: true }"
          :breakpoints="{
            768: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1070: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }"
        >
          <!-- 01 -->
          <SwiperSlide>
            <div class="list-item">
              <NuxtLink to="https://www.jnilbo.com/news/articleView.html?idxno=90000021254" class="item list-link">
                <div class="texts">
                  <div class="the-press" v-html="$t('전남일보')" />
                  <div class="post-title">
                    {{ $t('어머니사랑담긴언어로세상에평화전해요') }}
                  </div>
                  <div class="info">
                    <div class="country">
                      <span class="flag" style="background-image:url('https://pic.watv.org/imgFlag/flag-kr.gif')" />
                      <span class="country-name" v-html="formatIntlCountry('KR', locale)" />
                    </div>
                    <div class="date">
                      {{ formatIntlDate(new Date('2026-01-28'), locale) }}
                    </div>
                  </div>
                </div>
                <div class="photo" style="background-image:url(/images/news/news_260128_jeonnam.jpg)" />
              </NuxtLink>
            </div>
          </SwiperSlide>
          <!-- 02 -->
          <SwiperSlide>
            <div class="list-item">
              <NuxtLink to="https://www.kbsm.net/news/view.php?idx=506506" class="item list-link">
                <div class="texts">
                  <div class="the-press" v-html="$t('경북신문')" />
                  <div class="post-title">
                    {{ $t('경북경산서평화를부르는어머니사랑의언어세미나열어') }}
                  </div>
                  <div class="info">
                    <div class="country">
                      <span class="flag" style="background-image:url('https://pic.watv.org/imgFlag/flag-kr.gif')" />
                      <span class="country-name" v-html="formatIntlCountry('KR', locale)" />
                    </div>
                    <div class="date">
                      {{ formatIntlDate(new Date('2026-01-28'), locale) }}
                    </div>
                  </div>
                </div>
                <div class="photo" style="background-image:url(/images/news/news_260128_kbsm.jpg)" />
              </NuxtLink>
            </div>
          </SwiperSlide>
          <!-- 03 -->
          <SwiperSlide>
            <div class="list-item">
              <NuxtLink to="https://www.daejonilbo.com/news/articleView.html?idxno=2253462" class="item list-link">
                <div class="texts">
                  <div class="the-press" v-html="$t('대전일보')" />
                  <div class="post-title">
                    {{ $t('고마워요잘하고있어요대전서울려퍼진어머니사랑의기적') }}
                  </div>
                  <div class="info">
                    <div class="country">
                      <span class="flag" style="background-image:url('https://pic.watv.org/imgFlag/flag-kr.gif')" />
                      <span class="country-name" v-html="formatIntlCountry('KR', locale)" />
                    </div>
                    <div class="date">
                      {{ formatIntlDate(new Date('2026-01-27'), locale) }}
                    </div>
                  </div>
                </div>
                <div class="photo" style="background-image:url(/images/news/noimg.png)" />
              </NuxtLink>
            </div>
          </SwiperSlide>
          <!-- 04 -->
          <SwiperSlide>
            <div class="list-item">
              <NuxtLink to="https://m.sedaily.com/article/14172971" class="item list-link">
                <div class="texts">
                  <div class="the-press" v-html="$t('서울경제')" />
                  <div class="post-title">
                    {{ $t('하나님의교회어머니사랑의언어세미나성황') }}
                  </div>
                  <div class="info">
                    <div class="country">
                      <span class="flag" style="background-image:url('https://pic.watv.org/imgFlag/flag-kr.gif')" />
                      <span class="country-name" v-html="formatIntlCountry('KR', locale)" />
                    </div>
                    <div class="date">
                      {{ formatIntlDate(new Date('2026-01-20'), locale) }}
                    </div>
                  </div>
                </div>
                <div class="photo" style="background-image:url(/images/news/news_260120_seoul.jpg)" />
              </NuxtLink>
            </div>
          </SwiperSlide>
          <!-- 05 -->
          <SwiperSlide>
            <div class="list-item">
              <NuxtLink to="https://www.mk.co.kr/news/culture/11936899" class="item list-link">
                <div class="texts">
                  <div class="the-press" v-html="$t('매일경제')" />
                  <div class="post-title">
                    {{ $t('엄마는네편이야어머니사랑의언어세미나인기') }}
                  </div>
                  <div class="info">
                    <div class="country">
                      <span class="flag" style="background-image:url('https://pic.watv.org/imgFlag/flag-kr.gif')" />
                      <span class="country-name" v-html="formatIntlCountry('KR', locale)" />
                    </div>
                    <div class="date">
                      {{ formatIntlDate(new Date('2026-01-19'), locale) }}
                    </div>
                  </div>
                </div>
                <div class="photo" style="background-image:url(/images/news/news_260119_maeil.jpg)" />
              </NuxtLink>
            </div>
          </SwiperSlide>
          <!-- 06 -->
          <SwiperSlide>
            <div class="list-item">
              <NuxtLink to="https://shindonga.donga.com/culture/article/all/13/6033424/1" class="item list-link">
                <div class="texts">
                  <div class="the-press" v-html="$t('신동아')" />
                  <div class="post-title">
                    {{ $t('어머니사랑의언어로평화부르고봉사로인류애실천') }}
                  </div>
                  <div class="info">
                    <div class="country">
                      <span class="flag" style="background-image:url('https://pic.watv.org/imgFlag/flag-kr.gif')" />
                      <span class="country-name" v-html="formatIntlCountry('KR', locale)" />
                    </div>
                    <div class="date">
                      {{ formatIntlDate(new Date('2025-12-30'), locale) }}
                    </div>
                  </div>
                </div>
                <div class="photo" style="background-image:url(/images/news/noimg.png)" />
              </NuxtLink>
            </div>
          </SwiperSlide>

          <!-- 기존 -->
          <SwiperSlide>
            <div class="list-item">
              <NuxtLink to="https://weekly.donga.com/culture/article/all/11/5973151/1" class="item list-link">
                <div class="texts">
                  <div class="the-press" v-html="$t('주간동아')" />
                  <div class="post-title">
                    {{ $t('어머니사랑깃든언어로세상을따뜻하게') }}
                  </div>
                  <div class="info">
                    <div class="country">
                      <span class="flag" style="background-image:url('https://pic.watv.org/imgFlag/flag-kr.gif')" />
                      <span class="country-name" v-html="formatIntlCountry('KR', locale)" />
                    </div>
                    <div class="date">
                      {{ formatIntlDate(new Date('2025-11-21'), locale) }}
                    </div>
                  </div>
                </div>
                <div class="photo" style="background-image:url(/images/news/news_251121_donga.jpg)" />
              </NuxtLink>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div class="list-item">
              <NuxtLink to="https://www.m-joongang.com/news/articleView.html?idxno=401379" class="item list-link">
                <div class="texts">
                  <div class="the-press" v-html="$t('월간중앙')" />
                  <div class="post-title">
                    {{ $t('ai에인간존중가치불어넣자국제봉사단체asezai시대의어머니마음포럼개최') }}
                  </div>
                  <div class="info">
                    <div class="country">
                      <span class="flag" style="background-image:url('https://pic.watv.org/imgFlag/flag-kr.gif')" />
                      <span class="country-name" v-html="formatIntlCountry('KR', locale)" />
                    </div>
                    <div class="date">
                      {{ formatIntlDate(new Date('2025-07-18'), locale) }}
                    </div>
                  </div>
                </div>
                <div class="photo" style="background-image:url(/images/news/news_250718_joongang.jpg)" />
              </NuxtLink>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div class="list-item">
              <NuxtLink to="https://www.munhwa.com/article/11498955" class="item list-link">
                <div class="texts">
                  <div class="the-press" v-html="$t('문화일보')" />
                  <div class="post-title">
                    {{ $t('내가미안해힘들었지말한마디에행복찾아와') }}
                  </div>
                  <div class="info">
                    <div class="country">
                      <span class="flag" style="background-image:url('https://pic.watv.org/imgFlag/flag-kr.gif')" />
                      <span class="country-name" v-html="formatIntlCountry('KR', locale)" />
                    </div>
                    <div class="date">
                      {{ formatIntlDate(new Date('2025-04-15'), locale) }}
                    </div>
                  </div>
                </div>
                <div class="photo" style="background-image:url(/images/news/news_250415_munhwa.jpg)" />
              </NuxtLink>
            </div>
          </SwiperSlide>
        </Swiper>
      </ClientOnly>
    </div>
  </section>

  <!-- ********** Lists ********** -->
  <section class="section section-iframe">
    <div class="wrap">
      <div class="list-press">
        <client-only>
          <iframe
            id="news-iframe"
            ref="newsIframe"
            :src="`${DOMAIN}/${locale}/press/window?tags=1`"
            scrolling="no"
            :style="`width: 100%; overflow: hidden; height: ${height}px;`"
          />
        </client-only>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
// Head,Body
// swiper
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

const { locale } = useI18n()
const { $t } = useNuxtApp()

useHead({
  title: `${$t('언론보도')} - ${$t('어머니사랑과평화의날캠페인')}`,
  link: [
    { rel: 'stylesheet', href: `/css/press.css?${useBuildTime()}` },
  ],
})

// iframe
const height = ref(1530)
const newsIframe = ref<HTMLIFrameElement | null>(null)
const DOMAIN = 'https://watvpress.org'

function onMessage(event: MessageEvent) {
  if (event.origin !== DOMAIN)
    return // origin 검증

  const cw = newsIframe.value?.contentWindow
  if (cw && event.source !== cw)
    return // source 검증

  const { data, type } = event.data ?? {} // 데이터 추출
  switch (type) {
    case 'windowHeight':
      const h = Number(data) // height 값 추출
      if (!Number.isFinite(h) || h < 0)
        return
      height.value = h
      break
    case 'load' :
      const url = `https://heavenlymotherslove.org/css/iframe.css?v=${useBuildTime()}`
      newsIframe.value?.contentWindow?.postMessage({
        type: 'externalStyles',
        data: [url],
      }, DOMAIN)
      break
  }
}

onMounted(() => window.addEventListener('message', onMessage))
onBeforeUnmount(() => window.removeEventListener('message', onMessage))
//
</script>
